module.exports = __webpack_public_path__ + "img/un_used@2x.22565150.png";